module.exports = __webpack_public_path__ + "static/media/right-arrow-icon.20132d32.svg";